export default "__VITE_ASSET__38f207df__"